module.exports = __webpack_public_path__ + "static/media/207.fbc9658a.png";